var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":"centreLeft2Chart","height":"4.625rem","width":"4.125rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }